import React, { useEffect, useState, useRef} from 'react';
import "../scss/claimprocessing.scss";
import ClaimDetail from './claimDetail.jsx';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import TextTruncate from "../utilsComponent/textTruncate.jsx";
import Colors from '../utilsComponent/colors.jsx';
import { format,formatDistance } from 'date-fns';
import Form from 'react-bootstrap/Form';
import ReactPaginate from 'react-paginate';
import { REACT_APP_VAM_CONTEXT_INGESTION, REACT_APP_VAM_ENDPOINT, WRAPPER_SERVICE } from "../urls";
import { CONSTANTS, encryptValue, getChannelName, getFlagName, getPathName, saveInLocalStorage,titleCase } from '../utilFunctions.js';
import LoadingPage from '../reusableComponents/loader/loadingPage.jsx';
import AdvanceSearch from '../utilsComponent/advanceSearch.jsx';
import NoDataFound from '../utilsComponent/noDataFound.jsx';
import { toast } from 'react-toastify';
import { axiosRequest, axiosWithoutToken } from '../service.js';
import { getCalamityNames, getPortalNames } from './apiHelper.js';
import ViewMoreLess from '../reusableComponents/ViewMoreLess.jsx';
import "../scss/gisSurvey.scss";
import { PAGE_NAME_KEYS,GOVT_PRODUCT} from '../consts.js';

const ClaimProcessing = (props) => {
    const {productNames} = props
    const navigate = useNavigate();
    const location = useLocation();
    const [claimslist, setClaimslist] = useState([])
    const [currentItems, setCurrentItems] = useState([])
    const [searchResultMode, setSearchResultMode] = useState(false)
    const [perilList, setPerilList] = useState([]);
    const [cropList, setCropList] = useState([]);
    const [productID, setProductID] = useState([]);
    const [showAdvanceSearch, setShowAdvanceSearch] = useState()
    const [policyNumber, setpolicyNumber] = useState('');
    const [claimIntimationLists, setClaimIntimationLists] = useState([])
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [itemOffset, setItemOffset] = useState(1);
    const [selectedPage, setSelectedPage] = useState(1)
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(false)
    const [showClaimButtons, setShowClaimButtons] = useState(false)
    const [triggerAPi, setTriggerAPi] = useState(false)
    const [portalList, setPortalList] = useState([])
    const [totalRecords, setTotalRecords] = useState(0)
    const scrollRef = useRef(null);
    const [calamity,setCalamity]=useState([])
    const validPaths = [
        PAGE_NAME_KEYS.CLAIM_INTIMATION_DETAILS, PAGE_NAME_KEYS.GIS_SURVEY, PAGE_NAME_KEYS.LOSS_RESERVE, PAGE_NAME_KEYS.DOCUMENTS,
        PAGE_NAME_KEYS.FIELD_SURVEY, PAGE_NAME_KEYS.CLAIM_CALCULATION, PAGE_NAME_KEYS.CLAIM_PAYOUT, PAGE_NAME_KEYS.CLAIM_HISTORY,
        PAGE_NAME_KEYS.AUDIT_TRAIL, PAGE_NAME_KEYS.CLAIM_LITIGATION, PAGE_NAME_KEYS.MANAGE_STATUS, PAGE_NAME_KEYS.REMARKS_REQUEST
    ];    

    useEffect(() => {
        getPortalNames({setPortalList});
        getCalamityNames({setCalamity})
    }, [])
    const handleScroll = () => {  
        if (scrollRef.current) {
          const element = scrollRef.current;                  
          const scrollPosition = element.scrollHeight * 0.5;
          element.scrollTo({
            top: scrollPosition,
            behavior: 'smooth',
          });
          scrollRef.current?.scrollIntoView({ top: scrollPosition, behavior: 'smooth' })
        }
    }

    
    const defaultSearch = {
        assignedTo: "",
        role: "",
        claimStatus: "",
        claimSubStatus: "",
        claimID: "",
        policyID: "",
        mobileNo: "",
        alternateMobileNo: "",
        farmerID: "",
        pendingActions: "",
        productName: "",
        state: "",
        district: "",
        mandal: "",
        village: "",
        claimIngestionType:"",
        calamityType:"",
        policyStatus:"",
        seasonName:"",
        seasonYear:"",
        fromDate:"", // Intimation From date
        toDate:"", // Intimation To date
        crop:"",
        peril:"",
        vendorName:"",
        surveyorName:"",
        assignedTeamMemberId:"",
        email:"",
        isAttachmentAvailable:"",
        selectedFlags:"",
        createdBy:"",
    }
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [searchFields, setsearchFields] = useState(defaultSearch)

    // useEffect(() => {
    //     if (roleDataCookie?.roleName == "CALL_CENTRE") {
    //         toast.error("You are not authorized to view this page.")
    //         backPage()
    //         return
    //     }
    // }, [])

    const policySearch = (policyNumber, farmerID, claimNumber, productName, productID,claim) => {
        setLoading(true)
        setProductID(productID)
        let payload={};

            payload = {
            // Get policy details Using Policy id
                searchType: policyNumber !== null ? CONSTANTS.SEARCH_TYPE_POLICY_NUMBER : CONSTANTS.SEARCH_TYPE_TRANSACTION,
                product: productName,
                searchValue: policyNumber !== null ? policyNumber : claim?.policy?.tranId
            }
        axiosWithoutToken().post(`${WRAPPER_SERVICE}/search`, payload).then(data => {
            if (!policyNumber) {
                if (data?.data?.length > 0) {
                    let policyDetailsEncripted = encryptValue(JSON.stringify(data.data[0]))
                    saveInLocalStorage("policyDetail", policyDetailsEncripted)
                    getClaimDetails(claimNumber, true);
                } else {
                    toast.error("Unable to Fetch Policy Details.");
                }
            } else {
                if (data.data && data.data !== "No Data Present" && data.data.length > 0) {
                    let policyDetailsEncripted = encryptValue(JSON.stringify(data.data[0]))
                    saveInLocalStorage("policyDetail", policyDetailsEncripted)
                    getClaimDetails(claimNumber, true);
                } else {
                    toast.error("Unable to Fetch Policy Details.")
                }
            }
            setpolicyNumber(policyNumber)
            setLoading(false)
        }).catch(error => {
            toast.error("Unable to Fetch Policy Details.")
            console.log(error)
            setLoading(false)
        })
    }

    // useEffect(() => {
    //     const endOffset = itemOffset + itemsPerPage;
    //     setCurrentItems(claimslist.slice(itemOffset, endOffset));
    //     setPageCount(Math.ceil(claimslist.length / itemsPerPage));
    // }, [itemOffset, itemsPerPage, claimslist]);

    const handlePageClick = (event) => {
        // const newOffset = event.selected * itemsPerPage % claimslist.length;
        // setItemOffset(newOffset);
        setSelectedPage(event.selected + 1)
        setTriggerAPi(!triggerAPi)
    };
    const itemPerChangeHandler = (count) => {
        setItemsPerPage(count)
        setItemOffset(1)
        setSelectedPage(1)
        setTriggerAPi(!triggerAPi)
    }
    const getCalamityName = (id) => {
        const calamityname = calamity.filter((data) => {
            if (data.id == id) return data
        })
        return calamityname[0]?.name
    }
    const getClaimDetails = (claimNo, navigation, setData) => {
        setLoading(true)
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/claim-record/${claimNo}`).then(data => {
            let claimDetailsEncripted = encryptValue(JSON.stringify(data.data))
            saveInLocalStorage("claimDetail", claimDetailsEncripted)
            navigation && navigate(`/dashboard/${PAGE_NAME_KEYS.CLAIM_PROCESSING}/${PAGE_NAME_KEYS.CLAIM_INTIMATION_DETAILS}`)
            setData && setData(data.data)
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            setLoading(false)
        })
    }
    const navigateclaimprocessing = (data) => {
    };

    const findPortalName = (portalCode) => {
        const selectedValue = portalList.find(
            (option) => option.id === portalCode
        );
        return selectedValue?.name
    }
    return (
        <section className="p-4">
            <h1 className="headerclaim">
                Claim Processing
            </h1>

            <hr />
            {
                validPaths.includes(getPathName(location)) && (
                    <ClaimDetail
                        navigateclaimprocessing={navigateclaimprocessing}
                        policyNumber={policyNumber}
                        showClaimButtons={showClaimButtons}
                        setShowClaimButtons={setShowClaimButtons}
                        policySearch={policySearch}
                        loading={loading}
                        getClaimDetails={getClaimDetails}
                        productNames={productNames}
                        searchFields={searchFields}
                        claimslist={claimslist}
                    />
                )
            }
            {getPathName(location) == PAGE_NAME_KEYS.CLAIM_PROCESSING && (
                <div className="outer-boxclaim">
                    {/* <h2 className = "heading_h2" id = "search"
                    //className="heading"
                    //id="search"
                    //style={{paddingRight:"1000px"}}
                    >
                        Search
                    </h2> */}
                    <AdvanceSearch
                        loading={loading}
                        setLoading={setLoading}
                        showAdvanceSearch={showAdvanceSearch}
                        cropList={cropList}
                        setCropList={setCropList}
                        perilList={perilList}
                        setPerilList={setPerilList}
                        setList={setClaimslist}
                        searchFields={searchFields}
                        setsearchFields={setsearchFields}
                        setShowAdvanceSearch={setShowAdvanceSearch}
                        setProductID={setProductID}
                        productID={productID}
                        setSearchResultMode={setSearchResultMode}
                        module="claim_processing"
                        defaultSearch={defaultSearch}
                        resetFields={defaultSearch}
                        setSelectedPage={setSelectedPage}
                        selectedPage={selectedPage}
                        setItemsPerPage={setItemsPerPage}
                        itemsPerPage={itemsPerPage}
                        setPageCount={setPageCount}
                        triggerAPi={triggerAPi}
                        setTotalRecords={setTotalRecords}
                        productNames={productNames} 
                        handleScroll={() => handleScroll()}
                        selectedProducts = {selectedProducts}
                        setSelectedProducts = {setSelectedProducts}
                    />

                    <hr />
                    {loading ? (<LoadingPage></LoadingPage>) : (
                        <div className="claim-historyclaim" ref={scrollRef}>
                            {
                                searchResultMode && claimslist.length > 0 && (
                                        <h2
                                        className="heading_h2"
                                        id="history"
                                    >
                                        Search Results ({totalRecords})
                                        {/* <button className="btn btn-success" onClick={handleDownload}>Download</button> */}
                                    </h2>
                                    
                                        
                                )
                            }
                            {
                                loading ? <LoadingPage /> : (
                                    <div className={`${claimslist.length > 0 && 'overflowclaim'}`}>
                                        {!loading && claimslist.length > 0 ? (
                                            <table id="claim_historyclaim">
                                                <tbody>
                                                    <tr>
                                                        <th>
                                                            Claim Number
                                                        </th>
                                                        <th>
                                                            Policy Number
                                                        </th>
                                                        <th>
                                                            Transaction ID
                                                        </th>
                                                        <th>
                                                            Claim Created By
                                                        </th>
                                                        <th>
                                                            Claim Intimated By
                                                        </th>
                                                        <th>
                                                            Farmer Name
                                                        </th>
                                                        <th>
                                                            Source
                                                        </th>
                                                        <th>
                                                            Product Name
                                                        </th>
                                                        <th>
                                                            Intimated Date & time
                                                        </th>
                                                        <th>
                                                            Contact Number
                                                        </th>
                                                        <th>
                                                            Date & time of Peril Occurrence
                                                        </th>
                                                        <th>
                                                            Status
                                                        </th>
                                                        <th className="centerclaim">
                                                            Sub Status
                                                        </th>
                                                        <th>
                                                            Crop
                                                        </th>
                                                        <th>
                                                            Peril Type
                                                        </th>
                                                        <th>
                                                            Claim Ingestion Type
                                                        </th>
                                                        <th>
                                                            Calamity Type
                                                        </th>
                                                        <th>
                                                            Season
                                                        </th>
                                                        <th>
                                                            Year
                                                        </th>
                                                        <th>
                                                            Policy Status
                                                        </th>
                                                        <th>
                                                            Vendor Name
                                                        </th>
                                                        <th>
                                                            Surveyor Name
                                                        </th>
                                                        <th>
                                                            State
                                                        </th>
                                                        <th>
                                                            District
                                                        </th>
                                                        <th className='field-alignment'>
                                                            GIS Remarks
                                                        </th>
                                                        <th>
                                                            GIS Status
                                                        </th>
                                                        <th>
                                                            Survey Aging
                                                        </th>
                                                        <th>
                                                            Survey Status
                                                        </th>
                                                        <th>
                                                            QC Aging
                                                        </th>
                                                        <th>
                                                            QC Status
                                                        </th>
                                                        <th>
                                                            Assigned to
                                                        </th>
                                                        <th>
                                                            Role
                                                        </th>
                                                        <th>
                                                            Category
                                                        </th>
                                                        <th>
                                                            Flagged Claims
                                                        </th>
                                                    </tr>
                                                    {
                                                        claimslist && claimslist.length > 0 && claimslist.map(claimlist => (
                                                            <tr>
                                                                <td>
                                                                    <span className='text-primary' onClick={() => {
                                                                        policySearch(claimlist?.policy?.policyNumber, claimlist?.policy?.custemerID, claimlist.claimNo, claimlist.productName, claimlist.productID,claimlist)
                                                                    }}
                                                                    >
                                                                        {claimlist.claimNo ? <TextTruncate text={claimlist.claimNo} length={22} /> : "--"}
                                                                    </span>
                                                                </td>
                                                                <td className="policy_number">
                                                                    {claimlist?.policy?.policyNumber}
                                                                </td>
                                                                <td>
                                                                    {claimlist?.policy?.tranId || "--"}
                                                                </td>
                                                                <td>
                                                                    {claimlist?.createdBy || "--"}
                                                                </td>
                                                                <td>
                                                                    {claimlist?.claimIntimatedBy || "--"}
                                                                </td>
                                                                <td>
                                                                    {claimlist?.policy?.custmerName}
                                                                </td>
                                                                <td>
                                                                    {claimlist.channelID !== 11 ? getChannelName(claimlist.channelID) : findPortalName(claimlist.portalCode)}
                                                                </td>
                                                                <td className="">
                                                                    {claimlist?.productName ? claimlist?.productName : "--"}
                                                                </td>
                                                                <td className="">
                                                                    {format(new Date(claimlist.claimOpenDate), 'dd-MM-yyyy, hh:mm a')}
                                                                </td>
                                                                <td className="">
                                                                    {claimlist?.policy?.mobileNumber ? claimlist?.policy?.mobileNumber : "--"}
                                                                </td>
                                                                <td>
                                                                    {claimlist.dateAndTimeOfLoss ? format(new Date(claimlist.dateAndTimeOfLoss.split(".")[0]), 'dd-MM-yyyy, hh:mm a') : "--"}
                                                                </td>
                                                                <td className="inactive">
                                                                    {claimlist?.claimStatus ? <Colors status={claimlist.claimStatus} /> : "--"}
                                                                </td>
                                                                <td className="text-danger">
                                                                    {claimlist.claimSubstatus ? <Colors status={claimlist.claimSubstatus} /> : "--"}
                                                                </td>
                                                                <td >
                                                                    {claimlist.riskName ? <TextTruncate text={claimlist.riskName} length={10} /> : "--"}
                                                                </td>
                                                                <td>
                                                                    {claimlist.perilName ? <TextTruncate text={claimlist.perilName} length={25} /> : "--"}
                                                                </td>
                                                                <td>
                                                                    {claimlist.claimIngestionType === 1 ? 'Individual' : claimlist.claimIngestionType === 2 ? 'Area Based' : "--"}
                                                                </td>
                                                                <td>
                                                                    {claimlist.productType?getCalamityName(claimlist.productType):""}
                                                                </td>
                                                                <td>
                                                                    {claimlist?.policy?.seasonName ? claimlist?.policy?.seasonName :""}
                                                                </td>
                                                                <td>
                                                                    {claimlist?.policy?.seasonYear ? claimlist?.policy?.seasonYear :""}
                                                                </td>
                                                                <td>
                                                                    {claimlist?.policy?.status ? titleCase(claimlist?.policy?.status) : "--"}
                                                                </td>
                                                                <td>
                                                                    {claimlist?.vendor ? claimlist.vendor : ''}
                                                                </td>
                                                                <td>
                                                                {claimlist?.surveyor ? (
                                                                    <TextTruncate text={`${claimlist.surveyor.replace(' null', '')} ${claimlist.surveyor.includes(claimlist.surveyorMobileNumber) ? "": claimlist?.surveyorMobileNumber}`} length={20} />
                                                                    ) : ''}
                                                                </td>
                                                                <td className="">
                                                                    {claimlist?.policy?.state}
                                                                </td>
                                                                <td className="">
                                                                    {claimlist?.policy?.district}
                                                                </td>
                                                                <td>
                                                                    {claimlist?.gisRemarks ? ( <ViewMoreLess text={claimlist.gisRemarks} truncateLength={13} /> ) : ( "--")}
                                                                </td>
                                                                <td>
                                                                    {claimlist.gisSurvey}
                                                                </td>
                                                                <td>
                                                                {(claimlist?.surveyInitiatedDate) ? claimlist?.surveyReceivedDate ? formatDistance(new Date(claimlist?.surveyInitiatedDate), new Date(claimlist?.surveyReceivedDate)) : formatDistance(new Date(claimlist?.surveyInitiatedDate), new Date()) : ""}
                                                                
                                                                </td>
                                                                <td>
                                                                    {claimlist.fieldSurvey}
                                                                </td>
                                                                <td>
                                                                {(claimlist?.qcinitiatedDate) ? claimlist?.qcclosedDate ? formatDistance(new Date(claimlist?.qcinitiatedDate), new Date(claimlist?.qcclosedDate)) : formatDistance(new Date(claimlist?.qcinitiatedDate), new Date()) : ""}
                                                                </td>
                                                                <td>
                                                                    {claimlist.qcStatus}
                                                                </td>
                                                                <td>
                                                                    {claimlist.assignedTo ? claimlist.assignedTo : "--"}
                                                                </td>
                                                                <td>
                                                                    {claimlist.role ? claimlist.role : "--"}
                                                                </td>
                                                                <td>
                                                                    {claimlist.category ?  <TextTruncate text={claimlist.category} length={15} /> : "--"}
                                                                </td>
                                                                <td>
                                                                    {getFlagName(claimlist.flags)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>)
                                            : (
                                                <NoDataFound text={"No data Found"} />
                                            )}
                                        {
                                            claimslist && claimslist.length > 0 && (
                                                <div className="d-flex align-items-center justify-content-end">
                                                    <div className="d-flex">
                                                        Select Limit :
                                                        <Form className="ms-3">
                                                            {['radio'].map((type) => (
                                                                <div key={`inline-${type}`} className="mb-3">
                                                                    <Form.Check
                                                                        inline
                                                                        label="10"
                                                                        name="group1"
                                                                        type={type}
                                                                        //checked={itemsPerPage == 10}
                                                                        //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(10)}
                                                                        id={`inline-${type}-1`}
                                                                    >
                                                                        <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(10)} checked={itemsPerPage == 10} />
                                                                        <Form.Check.Label >10</Form.Check.Label>
                                                                    </Form.Check>
                                                                    <Form.Check
                                                                        inline
                                                                        //label="25"
                                                                        name="group1"
                                                                        type={type}
                                                                        //checked={itemsPerPage == 25}
                                                                        //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(25)}
                                                                        id={`inline-${type}-2`}
                                                                    >
                                                                        <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(25)} checked={itemsPerPage == 25} />
                                                                        <Form.Check.Label >25</Form.Check.Label>
                                                                    </Form.Check>
                                                                    <Form.Check
                                                                        inline
                                                                        label="50"
                                                                        name="group1"
                                                                        type={type}
                                                                        //checked={itemsPerPage == 50}
                                                                        //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(50)}
                                                                        id={`inline-${type}-3`}
                                                                    >
                                                                        <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(50)} checked={itemsPerPage == 50} />
                                                                        <Form.Check.Label >50</Form.Check.Label>
                                                                    </Form.Check>
                                                                </div>
                                                            ))}
                                                        </Form>
                                                    </div>
                                                    <ReactPaginate
                                                        nextLabel=">>"
                                                        onPageChange={(e) => handlePageClick(e)}
                                                        pageRangeDisplayed={3}
                                                        marginPagesDisplayed={2}
                                                        pageCount={pageCount}
                                                        forcePage={selectedPage - 1}
                                                        previousLabel="<<"
                                                        pageClassName="page-item"
                                                        pageLinkClassName="page-link"
                                                        previousClassName="page-item"
                                                        previousLinkClassName="page-link"
                                                        nextClassName="page-item"
                                                        nextLinkClassName="page-link"
                                                        breakLabel="..."
                                                        breakClassName="page-item"
                                                        breakLinkClassName="page-link"
                                                        containerClassName="pagination"
                                                        activeClassName="active"
                                                        renderOnZeroPageCount={null}
                                                    />
                                                </div>
                                            )
                                        }
                                    </div>
                                )
                            }
                        </div>
                    )}
                </div>)}
        </section>
    )
}

export default ClaimProcessing